export default __webpack_public_path__ + "static/14-21 Kiran et al-eb9c542266b7f6bdd47c933443aa1bd9.pdf";